import { Toaster } from "sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import Logistics from "@/components/site/Logistics";
import ImpactMap from "@/components/site/ImpactMap";
import DeploymentForm from "@/components/site/DeploymentForm";
import JoinMission from "@/components/site/JoinMission";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="relative bg-[#0B0C10] text-white font-body">
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#12131C",
            border: "1px solid rgba(255,255,255,0.12)",
            color: "#fff",
          },
        }}
      />
      <Navbar />
      <Hero />
      <Manifesto />
      <Logistics />
      <ImpactMap />
      <DeploymentForm />
      <JoinMission />
      <Footer />
    </main>
  );
}
